/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Code_LabelInputs */



/**
* | output |
* | --- |
* | "Or type the code from the email" |
*
* @param {Login_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_code_label = /** @type {((inputs?: Login_Code_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Code_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Of typ de code uit de e-mail")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ou saisissez le code de l'e-mail")
	return /** @type {LocalizedString} */ ("Or type the code from the email")
});